import React, { createContext, useContext } from "react";
import { useUserCategoriesService } from "../services/UserCategories.service";

let operationsAllowed = {};
const UserCategoriesFacadeContext = createContext(operationsAllowed);

export const UserCategoriesFacadeProvider = (props: any) => {

  const userCategoriesService = useUserCategoriesService();

  const getUserCategoriesActiveTabIndex = () => {
    return userCategoriesService.getUserCategoriesActiveTabIndex();
  }

  const setUserCategoriesActiveTabIndex = (activeTabIndex: number) => {
    userCategoriesService.setUserCategoriesActiveTabIndex(activeTabIndex);
  }

  operationsAllowed = {
    getUserCategoriesActiveTabIndex,
    setUserCategoriesActiveTabIndex
  };

  return (
    <UserCategoriesFacadeContext.Provider value={operationsAllowed}>
      {props.children}
    </UserCategoriesFacadeContext.Provider>
  );
};

export const useUserCategoriesFacade = () => {
  return useContext(UserCategoriesFacadeContext);
};
